import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	height: calc(100dvh - 80px);

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	gap: 24px;

	img {
		width: 200px;
	}
`;

export const ImgWrapper = styled.div`
	position: relative;
`;

export const BottomButtonWrapper = styled.div`
	width: 100%;
	max-width: 768px;

	padding: 15px 24px;

	display: flex;
	justify-content: center;
	align-items: center;
`;

export const TextContainer = styled.div`
	width: 100%;

	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const Title = styled.h1`
	color: ${({ theme }) => theme['font-primary']};
	text-align: center;
	font-family: 'Pretendard';
	font-size: 24px;
	font-style: normal;
	font-weight: 600;
	line-height: 32px; /* 133.333% */
`;

export const MessageIconWrapper = styled.div`
	position: absolute;
	top: 118px;
	right: -15px;
`;
